import MissingTripsModal from './MissingTripsModalContainer';

export default MissingTripsModal;
